export const FONTS = {
  MONTSERRAT_BOLD: "Montserrat-Bold",
  MONTSERRAT_REGULAR: "Montserrat-Regular",
  SOURCESANSPRO_BOLD: "SourceSansPro-Bold",
  SOURCESANSPRO_REGULAR: "SourceSansPro-Regular",
  SOURCESANSPRO_SEMIBOLD: "SourceSansPro-Semibold",
  MONTSERRAT_SEMIBOLD: "Montserrat-SemiBold",
};
